<section class="bg-white">
    <div class="pt-20 px-4 md:ml-[290px]">
      <h2 class="mb-4 text-3xl md:text-4xl tracking-tight font-extrabold text-start text-gray-900">My Transactions</h2>
      <div class="gap-8 lg:flex">
        <!-- Right content -->
        <div class="w-full">
          @if (isProcessing()) {
            <div class="flex justify-center">
              <svg aria-hidden="true" class="w-20 h-20 text-gray-200 animate-spin fill-primary-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
              <span class="sr-only">Loading...</span>
            </div>
          } @else {
          <!-- Cards -->
          @for (transaction of transactionList; track transaction.id; let i = $index) {
            <div class="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm ">
              <div class="border-b border-gray-100 pb-4">
                <div class="mb-4 md:mb-0 md:block lg:mb-4 xl:mb-0 xl:block">
                  <div class="">
                    <div class="mt-4 sm:mt-0">
                      <!-- <div class="grid grid-cols-12">
                        <div class="col-span-1 flex items-center">
                          <span class="mr-2 font-semibold text-gray-900">{{ (currentPage - 1) * limit + (i + 1) }}.</span>
                        </div>
                        <div class="col-span-6">
                          <a class="mb-2 block font-semibold text-gray-900 hover:underline sm:mb-0 sm:flex">{{transaction.description}}</a>
                        </div>
                        <div class="col-span-2 text-center">
                          <span 
                            class="inline-block items-center rounded px-2.5 py-0.5 text-xs font-medium"
                            [ngClass]="{
                              'bg-yellow-100 text-yellow-800': getTransactionStatus(transaction) === 'Pending',
                              'bg-green-100 text-green-800': getTransactionStatus(transaction) === 'Completed',
                              'bg-red-100 text-red-800': getTransactionStatus(transaction) === 'Expired'
                            }"
                          >
                            {{ getTransactionStatus(transaction) }}
                          </span>
                        </div>
                        <div class="col-span-3">
                          <span>Number of Approvals: {{transaction.approvalCount}}/{{approvalCount}}</span>
                        </div>
                      </div> -->
                      <div class="overflow-x-auto w-full">
                        <table class="min-w-full border-collapse text-sm">
                          <tbody>
                            <tr class="border-b border-gray-100 hover:bg-gray-50">
                              <!-- Number -->
                              <td class="py-3 px-2 text-center font-semibold text-gray-900 whitespace-nowrap">
                                {{ (currentPage - 1) * limit + (i + 1) }}.
                              </td>
                      
                              <!-- Description -->
                              <td class="py-3 px-2 w-1/2">
                                <a class="block font-semibold text-gray-900 hover:underline break-words">
                                  {{ transaction.description }}
                                </a>
                              </td>
                      
                              <!-- Status -->
                              <td class="py-3 px-2 w-[20%] text-center">
                                <span
                                  class="inline-block rounded px-2.5 py-0.5 text-xs font-medium"
                                  [ngClass]="{
                                    'bg-yellow-100 text-yellow-800': getTransactionStatus(transaction) === 'Pending',
                                    'bg-green-100 text-green-800': getTransactionStatus(transaction) === 'Completed',
                                    'bg-red-100 text-red-800': getTransactionStatus(transaction) === 'Expired'
                                  }"
                                >
                                  {{ getTransactionStatus(transaction) }}
                                </span>
                              </td>
                      
                              <!-- Approvals -->
                              <td class="py-3 px-2 w-[20%] text-center text-gray-700 whitespace-nowrap">
                                Number of Approvals:
                                <span class="font-medium text-gray-900">
                                  {{ transaction.approvalCount }}/{{ transaction.required_signatures }}
                                </span>
                              </td>
                              @if (connectedAddress != transaction.proposer && !isTransactionExpired(transaction)) {
                              <td class="py-3 px-2 w-[10%]">
                                  <div class="flex justify-center gap-2">
                                    <button
                                      type="button"
                                      (click)="approveTransaction(transaction)"
                                      [disabled]="isApproveDisabled(transaction, connectedAddress)"
                                      [ngClass]="{
                                        'bg-primary-600 hover:bg-primary-700 focus:ring-primary-300': !isApproveDisabled(transaction, connectedAddress),
                                        'bg-green-700 hover:bg-green-800 cursor-not-allowed': isApproveDisabled(transaction, connectedAddress)
                                      }"
                                      class="w-full rounded-lg px-3 py-2 text-sm font-medium text-white focus:outline-none focus:ring-4 md:w-auto transition"
                                    >
                                      {{
                                        (approvingSignals.get(transaction.tx_id_numeric)?.() || false)
                                          ? 'Approving...'
                                          : (isApproveDisabled(transaction, connectedAddress) ? 'Approved' : 'Approve')
                                      }}
                                    </button>
                
                                    <!-- <button
                                      type="button"
                                      (click)="approveTransaction(transaction.tx_id_numeric)"
                                      [disabled]="isApproveDisabled(transaction, connectedAddress)"
                                      [ngClass]="{'bg-green-100 cursor-not-allowed' : isApproveDisabled(transaction, connectedAddress)}"
                                      class="w-full rounded-lg bg-green-700 px-3 py-2 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 md:w-auto"
                                    >
                                      {{ (approvingSignals.get(transaction.tx_id_numeric)?.() || false) ? 'Approving...' : (isApproveDisabled(transaction, connectedAddress) ? 'Approved' : 'Approve') }}
                                    </button> -->
                
                                    <!-- <button type="button" (click)="approveTransaction(transaction.tx_id_numeric)" [disabled]="isApproveDisabled(transaction, connectedAddress)" [ngClass]="{'bg-green-100 cursor-not-allowed' : isApproveDisabled(transaction, connectedAddress)}"
                                      class="w-full rounded-lg bg-green-700 px-3 py-2 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 md:w-auto">
                                        {{(approvingSignals.get(transaction.tx_id_numeric)?.() || false) ? 'Approving...' : 'Approve'}}
                                    </button> -->
                                  </div>
                              </td>
                              }
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      
                    </div>
                  </div>
                </div>
                
                
              </div>
              <div class="my-4 mx-4 flex items-center gap-2 ">
                <svg class="w-4 h-4 text-gray-800" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
                </svg>
                <a class="text-blue-600 underline hover:text-blue-800 transition-colors" [href]="getExplorerUrl(transaction) + transaction.transaction_hash" target="_blank">View TransactionHash</a>
              </div>
              <!-- Your current header content -->
              <button type="button"
                (click)="toggleDetails(transaction.tx_id_numeric)"
                class="mt-2 mb-2 text-blue-500 hover:underline">
                {{ expandedTransactions.has(transaction.tx_id_numeric) ? 'Hide Details' : 'Show Details' }}
              </button>
              <!-- Expandable details -->
               @if (expandedTransactions.has(transaction.tx_id_numeric)) {
                <div class="mt-4 border-t pt-4">
                  <p><strong>Transaction Proposed Date:</strong></p>
                  <p >{{ getFormattedDateTime(transaction.tx_created_at) }}</p>
                  <p class="mt-2"><strong>Transaction Proposed By:</strong></p>
                  <p class="break-words">{{ transaction.proposer }}</p>
                  <p class="mt-2"><strong>Approved Signers:</strong></p>
                    @for (approval of transaction.approvals; track $index) {
                      <p class="break-words">{{approval.signer}}</p>
                    } @empty {
                      <p>NIL</p>
                    }
                </div>
               }
              @if (getTransactionStatus(transaction) === 'Expired') {
                <div class="flex mt-4 items-center rounded-lg bg-orange-50 px-4 py-3 text-sm text-orange-800" role="alert">
                  <svg class="me-2 hidden h-4 w-4 flex-shrink-0 sm:flex" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                  <span class="sr-only">Info</span>
                  <div>Expired on: <span class="font-medium">{{ getFormattedDateTime(transaction.tx_expires_at) }}</span></div>
                </div>
              }
            </div>
           } 
           @empty {
              <div class="flex justify-center">
                <span>No Data Found</span>
                  <!-- <svg aria-hidden="true" class="w-20 h-20 text-gray-200 animate-spin dark:text-gray-600 fill-primary-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                  <span class="sr-only">Loading...</span> -->
              </div>
            }
           @if (transactionList && transactionList.length > 0) {
            <nav class="mt-6 flex items-center justify-center sm:mt-8" aria-label="Page navigation example">
              <ul class="flex h-8 items-center -space-x-px text-sm">
                <!-- Previous Button -->
                <li>
                  <a (click)="onPageChange(currentPage - 1)" 
                    class="cursor-pointer ms-0 flex h-8 items-center justify-center rounded-s-lg border border-e-0 border-gray-300 bg-white px-3 leading-tight text-gray-500 hover:bg-gray-100 hover:text-gray-700"
                    [class.cursor-not-allowed]="currentPage === 1"
                    [class.opacity-50]="currentPage === 1">
                    <span class="sr-only">Previous</span>
                    <svg class="h-4 w-4 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m15 19-7-7 7-7" />
                    </svg>
                  </a>
                </li>
                <!-- Page Numbers -->
                @for (page of [].constructor(totalPages); track $index; let i = $index) {
                <li>
                  <a
                    (click)="onPageChange(i + 1)"
                    [class.z-10]="currentPage === i + 1"
                    [class.bg-primary-50]="currentPage === i + 1"
                    [class.text-primary-600]="currentPage === i + 1"
                    class="flex h-8 items-center justify-center border cursor-pointer border-gray-300 bg-white px-3 leading-tight text-gray-500 hover:bg-gray-100 hover:text-gray-700 ">
                    {{ i + 1 }}
                  </a>
                </li>
              }
                <!-- Next Button -->
                <li>
                  <a (click)="onPageChange(currentPage + 1)"
                    class="cursor-pointer flex h-8 items-center justify-center rounded-e-lg border border-gray-300 bg-white px-3 leading-tight text-gray-500 hover:bg-gray-100 hover:text-gray-700 "
                    [class.cursor-not-allowed]="currentPage === totalPages"
                    [class.opacity-50]="currentPage === totalPages">
                    <span class="sr-only">Next</span>
                    <svg class="h-4 w-4 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7" />
                    </svg>
                  </a>
                </li>
              </ul>
            </nav>
           }
          }
        </div>
      </div>
    </div>
  </section>